import { useQuery } from "@tanstack/react-query";
import { getAllRoles } from "../../services/admin/role-service";

export const useGetAllRoles = () => {
  return useQuery({
    queryKey: ["all-roles"],
    queryFn: async () => {
      const response = await getAllRoles();

      if (!response.success) {
        throw new Error(response.message || "Failed to fetch roles");
      }

      return response?.data?.data || []; 
    },
    staleTime: 1000 * 60 * 5, 
  });
};


